export const setUserProfile = (userProfile: any) => ({
    type: 'SET_USERPROFILE',
    payload: userProfile,
  });
  